import { render } from "./TileCarousel.vue?vue&type=template&id=4c237026&scoped=true"
import script from "./TileCarousel.vue?vue&type=script&lang=js"
export * from "./TileCarousel.vue?vue&type=script&lang=js"

import "./TileCarousel.vue?vue&type=style&index=0&id=4c237026&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4c237026"]])

export default __exports__